import { useState } from "react";
/*
 *For Image Lazy Loading
 */
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";


function Image({ src }) {
  const [isSelected, setIsSelected] = useState(false);
  return (
    <LazyLoadImage
      alt={src.title}
      height={src.height}
      effect="blur"
      src={`${src.title}.png`}
      width={src.width}
      className={`${isSelected && "border-4 rounded-lg border-blue border-rounded"}`}
      onClick={() => setIsSelected(!isSelected)}
    />
  );
}

export default Image;
